import Vue from "vue";
import VueRouter from 'vue-router'
import home from '../view/home.vue'
import News from '../view/News.vue'
import About from '../view/About.vue'
import Product from '../view/Product.vue'
import Download from '../view/Download.vue'
import Service from '../view/Service.vue'
import Example from '../view/Example.vue'
import Buy from '../view/Buy.vue'
import wt8 from '../view/Feature/wt8.vue'
import wt9 from '../view/Feature/wt9.vue'
import wh11 from '../view/Feature/wh11.vue'
import wh12 from '../view/Feature/wh12.vue'
import Feature from '../view/Feature/index.js'
import strategy from '../view/strategy.vue'
Vue.use(VueRouter)
const routes = [

  {
    path:"/home",
    component:home,
    name:"home",

  },
  {
    path:"/Feature",
    component:Feature,
    name:"Feature",
    children:[
      {
        path:"wt8",
        component:wt8,
        name:"wt8",
      },
      {
        path:"wt9",
        component:wt9,
        name:"wt9",
      },
      {
        path:"wh11",
        component:wh11,
        name:"wh11",
      },
      {
        path:"wh12",
        component:wh12,
        name:"wh12",
      },
      {
        path: '',
        redirect: 'wt8'
      }
    ]
  },
  {
    path:"/News",
    component:News,
    name:"News",

  },
  {
    path:"/Download",
    component:Download,
    name:"Download",

  },
  // {
  //   path:"/strategy",
  //   component:strategy,
  //   name:"strategy",
    
  // },
  {
    path: "/Example",
    component: Example,
    name: "Example",

  },
  {
    path: "/About",
    component: About,
    name: "About",

  },
  {
    path:"/Product",
    component:Product,
    name:"Product",

  },
  {
    path: "/Service",
    component: Service,
    name: "Service",

  },
  {
    path: "/Buy",
    component: Buy,
    name: "Buy",

  },

  {
    path: '*',
    redirect: '/home'
  }


]

const router = new VueRouter({
  mode: 'hash',

  routes
})
export default router